<script lang="ts">
import Discord from '../../icons/Discord.svelte';
import ActionButton from "../ActionButton.svelte";

const { short = false } = $props();
</script>

<ActionButton buttonId='discord' href='https://discord.gg/9p7RnsffHe'>
  <Discord size=1.5em />
  {#if !short}
    Join the
  {/if}
  Discord
</ActionButton>
